import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';


export const verifyAccount = createAsyncThunk(
    'verifyAccount/verify',
    async ({ token, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/admin/activate-user-account`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }

            );
            if (response.data.status) {
                toast.success(response.data.response)

                return response.data
            }
        } catch (err) {
            toast.error(err.response.data.message)

            const message =
                err.response?.data?.message ||
                err.message ||
                'Verification failed';
            return rejectWithValue(message);
        }
    }
);

const initialState = {
    loading: false,
    error: null,
};

const verifyAccountSlice = createSlice({
    name: 'verifyAccount',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(verifyAccount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;

            })
            .addCase(verifyAccount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Verification failed';

            });
    },
});

export default verifyAccountSlice.reducer;